import { TerminalTypes } from "../constants/AppConstants";
import handleCallback from "../helper/APICallback";
import { getAppType } from "../helper/getAppType";
import { getDeviceType } from "../helper/getDeviceType";
import APIService from "./apiService";
import AuthService from "./authService";

//-------------------------------------------------------------------

const deviceType = getDeviceType();
const API = AuthService.getRemoteURL();
const Auth_API = {
  signin(options) {
    return new Promise((resolve, reject) => {
      APIService.fetch(
        `${API}/api/v1/POS/auth/merchant/terminal-signin`,
        {
          method: "POST",
          body: JSON.stringify(options),
          headers: {
            "Content-Type": "application/json",
            deviceid: AuthService.getDeviceId(),
            deviceinfo: deviceType,
            terminaltype: TerminalTypes.USER,
            appType: getAppType(deviceType),
          },
        },
        handleCallback(resolve, reject)
      );
    });
  },
  signup(options) {
    return new Promise((resolve, reject) => {
      APIService.fetch(
        `${API}/api/v1/auth/signup`,
        {
          method: "POST",
          body: JSON.stringify(options),
          headers: {
            "Content-Type": "application/json",
            deviceid: AuthService.getDeviceId(),
            deviceinfo: deviceType,
            terminaltype: TerminalTypes.USER,
            appType: getAppType(deviceType),
          },
        },
        handleCallback(resolve, reject)
      );
    });
  },
  refresh(refreshToken) {
    return new Promise((resolve, reject) => {
      APIService.fetch(
        `${API}/api/v1/POS/auth/refresh-access`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${refreshToken}`,
            deviceid: AuthService.getDeviceId(),
            deviceinfo: deviceType,
            terminaltype: TerminalTypes.USER,
            appType: getAppType(deviceType),
          },
        },
        handleCallback(resolve, reject)
      );
    });
  },
  logout(options) {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          url: `${API}/api/v1/POS/auth/merchant-key/signout`,
          method: "POST",
          data: JSON.stringify(options),
          headers: { "Content-Type": "application/json" },
        },
        handleCallback(resolve, reject)
      );
    });
  },
  verifyBillingKey(options) {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          url: `${API}/api/v1/POS/auth/verify/billing-key`,
          method: "POST",
          data: JSON.stringify(options),
          headers: { "Content-Type": "application/json" },
        },
        handleCallback(resolve, reject)
      );
    });
  },
};
export default Auth_API;
